import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {
  Alert,
  Avatar,
  Button,
  CssBaseline,
  TextField,
  Typography,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Box, Container } from "@mui/system";
import React, { useState } from "react";
import { TOKEN, USER, USERNAME } from "../../constante/localStorage";
import { useUserPreferences } from "../../hooks/useUserPreferences";
import { Login } from "../../models/Login";
import { setToken, setUser } from "../../redux/features/appStateSlice";
import { planoAPI } from "../../redux/features/cache";
import { useAppDispatch } from "../../redux/store";

const theme = createTheme();

export interface IConnectionPageProps { }

export default function PlanogrammePage(props: IConnectionPageProps) {
  const dispatch = useAppDispatch();

  const [login] = planoAPI.endpoints.login.useMutation();

  const [getUserPreferences] = planoAPI.endpoints.getUserPreferences.useLazyQuery();
  const storedUserPreferences = useUserPreferences();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [connectionFailed, setConnectionFailed] = useState(false);

  const onChangeUsername = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    setUsername(e.target.value);
  };
  const onChangePassword = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    setPassword(e.target.value);
  };
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // const result: Login = 
    await login({ user: username, password })
      .unwrap()
      .then(async (result: Login) => {
        dispatch(planoAPI.util.resetApiState());

        if (result.success) {
          localStorage.setItem(TOKEN, result.token);
          localStorage.setItem(USER, result.user);
          localStorage.setItem(USERNAME, result.name);

          const userPreferences = await getUserPreferences({ usager: result.user, token: result.token }).unwrap();
          storedUserPreferences.setUserPreferences(userPreferences);

          dispatch(setUser(username));
          dispatch(setToken(result.token));

          setConnectionFailed(false);
        } else {
          setConnectionFailed(true);
        }
      })
      .catch((error) => {
        setConnectionFailed(true);
        console.log("Error: ", error)
      });
  };

  return (
    <div>
      <ThemeProvider theme={theme}>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <Box
            sx={{
              marginTop: 8,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Authentification
            </Typography>
            <Box
              component="form"
              onSubmit={(e) => {
                handleSubmit(e);
              }}
              sx={{ mt: 1 }}
            >
              <Alert severity="error" hidden={!connectionFailed}>La connexion a échoué, réessayer!</Alert>
              <TextField
                margin="normal"
                required
                onChange={(e) => {
                  onChangeUsername(e);
                }}
                fullWidth
                id="email"
                label="Nom d'utilisateur"
                name="user"
                autoFocus
              />
              <TextField
                margin="normal"
                required
                fullWidth
                onChange={(e) => {
                  onChangePassword(e);
                }}
                name="password"
                label="Mot de passe"
                type="password"
                id="password"
                autoComplete="current-password"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Se connecter
              </Button>
            </Box>
          </Box>
        </Container>
      </ThemeProvider>
    </div>
  );
}

